module.exports = __webpack_public_path__ + "static/media/transparency.5c6537da.svg";